import { render } from "./LoginLogin.vue?vue&type=template&id=3b7894a0&scoped=true"
import script from "./LoginLogin.vue?vue&type=script&lang=js"
export * from "./LoginLogin.vue?vue&type=script&lang=js"

import "./LoginLogin.vue?vue&type=style&index=0&id=3b7894a0&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7894a0"]])

export default __exports__